import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	loadingUimFailed: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	loadingUimDataFailed: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	applyingUimFailed: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	appDoesNotHaveRequiredScopes: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	loadingUimFailed: {
		id: 'ui-modifications-view-gic.use-ui-modifications-errors.loading-uim-failed',
		defaultMessage: "We couldn't load the UI modifications for this form.",
		description:
			'A warning that gets displayed when unknown error occurred during UI modifications processing in Jira',
	},
	loadingUimDataFailed: {
		id: 'ui-modifications-view-gic.use-ui-modifications-errors.loading-uim-data-failed',
		defaultMessage: "We couldn't load the UI modifications configuration for this form.",
		description:
			'A warning that gets displayed when known error occurred during UI modifications data loading in Jira',
	},
	applyingUimFailed: {
		id: 'ui-modifications-view-gic.use-ui-modifications-errors.applying-uim-failed',
		defaultMessage: 'We encountered an error while applying UI modifications to this form.',
		description:
			'A warning that gets displayed when known error occurred during UI modifications processing in Jira',
	},
	appDoesNotHaveRequiredScopes: {
		id: 'ui-modifications-view-gic.use-ui-modifications-errors.app-does-not-have-required-scopes',
		defaultMessage:
			'We couldn’t load some of the UI modifications apps for this page, because they don’t have required scopes.',
		description:
			'A warning that gets displayed when an app with UI modifications module does not have required scopes in the manifest',
	},
});
export default messages;
